export const Welcome = {
  HeaderText: 'header-text',
  SubmitBtn: 'submit-btn',
};